export const BUCKET_MEDIA_PATH = "media";

export const ModelType = {
    FAST: "fast",
    THINKING: "thinking",
};